module.exports = __webpack_public_path__ + "img/intlSeafarer_62722KV.429d396c.jpg";